import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=f9c3d02c&"
import script from "./Visits.vue?vue&type=script&lang=ts&"
export * from "./Visits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports